/**
 * Cold-Arrival Guarantee Interactive Component
 * Handles desktop tooltip and mobile bottom sheet interactions
 */
(function() {
  'use strict';
  
  // Prevent multiple initializations
  if (window.gtcColdGuaranteeInitialized) {
    return;
  }
  window.gtcColdGuaranteeInitialized = true;

  // Wait for DOM to be ready
  function init() {
    const isMobile = () => window.innerWidth <= 749;
    const badge = document.getElementById('coldGuaranteeBadge');
    const sheet = document.getElementById('guaranteeSheet');
    const overlay = document.getElementById('sheetOverlay');
    
    if (!badge) {
      console.warn('[Cold Guarantee] Badge element not found');
      return;
    }

    // Mobile: Bottom Sheet Interactions
    if (sheet && overlay) {
      const closeBtn = sheet.querySelector('.sheet-close');
      const gotItBtn = sheet.querySelector('.sheet-cta');

      // Open sheet on badge tap (mobile only)
      badge.addEventListener('click', function(e) {
        if (!isMobile()) return;
        
        e.preventDefault();
        e.stopPropagation();
        sheet.style.display = 'block';
        overlay.style.display = 'block';
        sheet.classList.add('active');
        overlay.classList.add('active');
        document.body.classList.add('guarantee-sheet-open');
        
        // Analytics tracking
        trackEvent('guarantee_viewed', 'Mobile Bottom Sheet');
      });

      // Close sheet function
      function closeSheet() {
        sheet.classList.remove('active');
        overlay.classList.remove('active');
        document.body.classList.remove('guarantee-sheet-open');
        sheet.style.display = 'none';
        overlay.style.display = 'none';
      }

      // Close button
      if (closeBtn) {
        closeBtn.addEventListener('click', closeSheet);
      }

      // "Got it!" button
      if (gotItBtn) {
        gotItBtn.addEventListener('click', function() {
          closeSheet();
          trackEvent('guarantee_cta_clicked', 'Mobile Got It');
        });
      }

      // Close on overlay click
      overlay.addEventListener('click', closeSheet);

      // Close on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && sheet.classList.contains('active')) {
          closeSheet();
        }
      });
    }

    // Desktop: Tooltip hover tracking
    if (!isMobile()) {
      let hoverTracked = false;
      
      badge.addEventListener('mouseenter', function() {
        if (!hoverTracked) {
          trackEvent('guarantee_hovered', 'Desktop Tooltip');
          hoverTracked = true;
        }
      });
    }

    // Accessibility: Keyboard navigation
    badge.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        
        if (isMobile() && sheet) {
          badge.click();
        }
      }
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Close sheet if resizing to desktop
        if (!isMobile() && sheet && sheet.classList.contains('active')) {
          sheet.classList.remove('active');
          overlay.classList.remove('active');
          document.body.classList.remove('guarantee-sheet-open');
        }
      }, 250);
    });

    console.log('[Cold Guarantee] Initialized successfully');
  }

  /**
   * Track analytics event
   * @param {string} eventName - GA4 event name
   * @param {string} label - Event label
   */
  function trackEvent(eventName, label) {
    try {
      // Google Analytics 4
      if (typeof gtag !== 'undefined') {
        gtag('event', eventName, {
          event_category: 'Trust Badge',
          event_label: label,
          value: 1
        });
      }
      
      // Google Tag Manager (alternative)
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: eventName,
          eventCategory: 'Trust Badge',
          eventLabel: label,
          eventValue: 1
        });
      }
      
      console.log(`[Cold Guarantee] Event tracked: ${eventName} - ${label}`);
    } catch (error) {
      console.error('[Cold Guarantee] Analytics tracking error:', error);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

